export const IN_SLA_PROPERTY_VALUE = '0';
export const BREACHED_PROPERTY_VALUE = '1';
export const SLA_WARNING_PROPERTY_VALUE = '2';
export const RESOLVED_IN_SLA_PROPERTY_VALUE = '3';
export const RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE = '4';

// If HELP_DESK_VIEW_MEMBER_SLA_PAUSED_STATUS_PROP_NAME === "paused", then the ticket's SLAs are paused
export const PAUSED_STATUS_VALUE = 'paused';
export let SLAStatus;

// Maps the SLA status property human-readable name to the ticket property value
// This applies to:
// - HELP_DESK_VIEW_MEMBER_SLA_TIME_TO_FIRST_RESPONSE_STATUS_PROP_NAME,
// - HELP_DESK_VIEW_MEMBER_SLA_TIME_TO_NEXT_RESPONSE_STATUS_PROP_NAME
// - HELP_DESK_VIEW_MEMBER_SLA_TIME_TO_CLOSE_STATUS_PROP_NAME
(function (SLAStatus) {
  SLAStatus["IN_SLA"] = "IN_SLA";
  SLAStatus["BREACHED"] = "BREACHED";
  SLAStatus["SLA_WARNING"] = "SLA_WARNING";
  SLAStatus["RESOLVED_IN_SLA"] = "RESOLVED_IN_SLA";
  SLAStatus["RESOLVED_OUTSIDE_SLA"] = "RESOLVED_OUTSIDE_SLA";
})(SLAStatus || (SLAStatus = {}));
export const SLA_STATUS_TO_PROPERTY_VALUE = {
  [SLAStatus.IN_SLA]: IN_SLA_PROPERTY_VALUE,
  [SLAStatus.BREACHED]: BREACHED_PROPERTY_VALUE,
  [SLAStatus.SLA_WARNING]: SLA_WARNING_PROPERTY_VALUE,
  [SLAStatus.RESOLVED_IN_SLA]: RESOLVED_IN_SLA_PROPERTY_VALUE,
  [SLAStatus.RESOLVED_OUTSIDE_SLA]: RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE
};
export let SLAType;
(function (SLAType) {
  SLAType["TIME_TO_CLOSE"] = "TIME_TO_CLOSE";
  SLAType["TIME_TO_RESPOND"] = "TIME_TO_RESPOND";
})(SLAType || (SLAType = {}));
export const FIRST_RESPONSE_SLA = 'FIRST_RESPONSE_SLA';
export const CLOSE_TICKET_SLA = 'CLOSE_TICKET_SLA';
export const NEXT_RESPONSE_SLA = 'NEXT_RESPONSE_SLA';